import { render, staticRenderFns } from "./VireedSidebarProject.vue?vue&type=template&id=9f9df1b4&"
import script from "./VireedSidebarProject.vue?vue&type=script&lang=js&"
export * from "./VireedSidebarProject.vue?vue&type=script&lang=js&"
import style0 from "./VireedSidebarProject.vue?vue&type=style&index=0&id=9f9df1b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports